import { render, staticRenderFns } from "./orderReview.vue?vue&type=template&id=216b77c5&scoped=true"
import script from "./orderReview.vue?vue&type=script&lang=js"
export * from "./orderReview.vue?vue&type=script&lang=js"
import style0 from "./orderReview.vue?vue&type=style&index=0&id=216b77c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b77c5",
  null
  
)

export default component.exports